
        var result = require("!!../../../../../../node_modules/css-loader/index.js!./create-edit-customer-modal.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/quote-settings/customers/create-edit-customer-modal/create-edit-customer-modal.component.css
// module id = 748
// module chunks = 0